import React, { Fragment } from 'react'
import classNames from 'classnames'
import { map, toPairs } from 'lodash/fp'

import styles from './interpolateNewline.module.css'

/**
 * Moves text inside tag into separate line
 *
 * @param {Object} options - interpolate options
 * @param {string} options.className - class used for wrapper tag
 * @param {boolean} options.interpolate - tells if the interpolation is active
 * @param {string} options.tag - tag used inside translation file that wraps
 * the text
 *
 * @returns {Object} result - JSX representation of the interpolated text
 *
 * @example
 * values: {
 *  ...interpolateNewline({ className: 'class', tag: 'newline' })
 * }
 */
export default function interpolateNewline({
  className,
  interpolate = true,
  tag,
}: {
  className?: string
  interpolate?: boolean
  tag?: string
} = {}) {
  return {
    [tag || 'newline']: (...chunks: string[]) =>
      interpolate ? (
        <span className={classNames(styles.line, className)}>
          {map(
            ([index, chunk]) => (
              <Fragment key={index}>{chunk}</Fragment>
            ),
            toPairs(chunks),
          )}
        </span>
      ) : (
        chunks
      ),
  }
}
